<app-loader *ngIf="isDisabled"></app-loader>
<div class="pt-1">
    <div class="card">
        <div class="card-header">
            <div class="card-title">Site User Creation</div>
        </div>
        <div class="card-body">
            <form name="FilterForm" (ngSubmit)="Validate(FilterForm)" #FilterForm="ngForm">
                <div class="row m-1">
                    <div class="col-md-3">
                        <label class="Label">Branch<span class="text-danger">*</span></label>
                        <ng-select [items]="Branchs" bindLabel="BranchName" bindValue="BranchMasterID"
                            placeholder="Select Branch" [(ngModel)]="Filter.BranchId" name="Branch"
                            (change)="ComboLoad('Client');change();" required>
                        </ng-select>
                        <div class="invalid-feedback">
                            Please select branch.
                        </div>
                    </div>
                    <div class="col-md-3">
                        <label class="Label">Client<span class="text-danger">*</span></label>
                        <ng-select [items]="Clients" bindLabel="ClientGroupName" bindValue="ClientGroupMasterID"
                            placeholder="Select Client" [(ngModel)]="Filter.ClientID" name="Client"
                            (change)="ComboLoad('Site');change();" required>
                        </ng-select>
                        <div class="invalid-feedback">
                            Please select client.
                        </div>
                    </div>
                    <div class="col-md-5">
                        <label class="Label">Site</label>
                        <ng-select [items]="Sites" bindLabel="SiteName" bindValue="SiteMasterID"
                            placeholder="Select Site" [(ngModel)]="Filter.SiteID" name="Site" (change)="change();">
                        </ng-select>
                        <div class="invalid-feedback">
                            Please select site.
                        </div>
                    </div>
                    <div class="col-md-auto pt-4">
                        <button type="submit" class="btn btn-primary text-nowrap" [disabled]="isDisabled">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Load':'Loading...'}}</button>
                    </div>
                </div>
            </form>
            <div class="row">
                <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
                    <thead class="table-light">
                        <tr>
                            <th scope="col" style="width: 5px;">#</th>
                            <th scope="col" style="width: 30px;">
                                <input class="form-check-input" type="checkbox" id="IsCheckAll" name="IsCheckAll"
                                    (click)="SUCheck($event,0,true)">
                                Check
                            </th>
                            <th>Branch Name</th>
                            <th>Client Name</th>
                            <th>Site Code</th>
                            <th>Site Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let TableData of TableDatas; let i = index">
                            <th scope="row" style="width: 5px;"
                                [ngClass]="{'grey-background': TableData.IsSiteUserCreation}">{{i+1}}</th>
                            <td class="text-center" style="width: 40px;"
                                [ngClass]="{'grey-background': TableData.IsSiteUserCreation}">
                                <div style="width: 80px;"><input class="form-check-input"
                                        *ngIf="!TableData.IsSiteUserCreation" type="checkbox" name="IsCheck "
                                        [(ngModel)]="TableData.checked" (click)="SUCheck($event,i)">
                                </div>
                            </td>
                            <td [ngClass]="{'grey-background': TableData.IsSiteUserCreation}">
                                {{TableData['BranchName']}}</td>
                            <td [ngClass]="{'grey-background': TableData.IsSiteUserCreation}">
                                {{TableData['ClientName']}}</td>
                            <td [ngClass]="{'grey-background': TableData.IsSiteUserCreation}">{{TableData['SiteCode']}}
                            </td>
                            <td [ngClass]="{'grey-background': TableData.IsSiteUserCreation}">{{TableData['SiteName']}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col"></div>
                <div class="col-auto">
                    <button *ngIf="this.common.PageRight.IsAdd || this.common.PageRight.IsEdit" type="button"
                        class="btn btn-primary" [disabled]="isDisabled" (click)="save()"><i class="bi bi-save2"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Submit':'Loading...'}}</button>
                </div>
            </div>
        </div>
    </div>
</div>